export function updateState(state, newState) {
  const changes = {};
  for (const [key, value] of Object.entries(newState)) {
    if (value !== state[key]) {
      changes[key] = value;
    }
  }

  const result = Object.keys(changes).length > 0 ? { ...state, ...changes } : state;
  return result;
}

export const updateMols = (mols, newMol, molIndex) => {
  const newMols = [...mols.slice(0, molIndex), newMol, ...mols.slice(molIndex + 1)];
  return newMols;
};

export const updateSelected = (selected, newSelected, molIndex) => {
  const updatedSelected = [...selected.slice(0, molIndex), newSelected, ...selected.slice(molIndex + 1)];
  return updatedSelected;
};
